module.exports = __webpack_public_path__ + "img/组件4.b1f77823.png";